export default __webpack_public_path__ + "static/media/ye.1f14fe44.svg";